class NavigationHover {
    static init() {
        this.$menu = $(".js-menu");
        this.$nav = $(".js-nav");
        this.$morph = $(".js-nav-morph");
        this.$morphDropdown = $(".js-nav-dropdown-list");

        this.shown = false;
        this.currentItem = null;

        this.bindEvents();
    }

    static bindEvents() {
        const me = this;
        this.$nav.on("mouseenter", ".js-menu-item", function () {
            if ($(window).outerWidth() >= 960) {
                me.updatePosition($(this).attr("data-content"));
                setTimeout(() => me.show());
            }
        });
        this.$menu.on("mouseleave", ".js-menu-item, .js-nav-dropdown-list", function () {
            me.hide();
        }).on("mouseenter", ".js-nav-dropdown-list", () => this.show());

        $(window).on("resize", () => {
            if (this.shown) {
                if ($(window).outerWidth() >= 960 && this.currentItem !== null) {
                    this.updatePosition(this.currentItem);
                } else {
                    this.hide();
                }
            }
        })
    }

    static updatePosition(item) {
        this.currentItem = item;
        let $navItem = $(".js-menu-item[data-content='" + item + "']");
        let $item = $("#" + item);
        let $list = $item.find(".menu__content");

        let passedItem = false;


        this.$morphDropdown.find(".menu__dropdown-inner").each((index, el) => {
            let $el = $(el);
            if (el === $item[0]) {
                $el.addClass("menu__dropdown-inner--active").removeClass("menu__dropdown-inner--off-left menu__dropdown-inner--off-right");
                passedItem = true;
                return;
            }
            if (!passedItem) {
                $el.addClass("menu__dropdown-inner--off-left").removeClass("menu__dropdown-inner--active menu__dropdown-inner--off-right")
            } else {
                $el.addClass("menu__dropdown-inner--off-right").removeClass("menu__dropdown-inner--active menu__dropdown-inner--off-left")
            }
        });

        let width = Math.round($list.outerWidth());
        let height = Math.round($list.height());

        let left = Math.floor($navItem.position().left + this.$nav.offset().left + ($navItem.outerWidth() / 2) - (width / 2));

        this.$nav.find(".menu__item--dropdown-active").removeClass("menu__item--dropdown-active");
        $navItem.addClass("menu__item--dropdown-active");

        this.$morphDropdown.css({
            width: width,
            height: height,
            transform: 'translateX(' + left + 'px)'
        });
    }

    static show() {
        if (this.hideTimeout) clearTimeout(this.hideTimeout);
        this.shown = true;

        this.$morph.addClass("menu__morph--active");
    }

    static hide() {
        if (this.hideTimeout) clearTimeout(this.hideTimeout);
        this.shown = false;

        this.hideTimeout = setTimeout(() => {
            this.$morph.removeClass("menu__morph--active");
            this.$morphDropdown.find(".menu__dropdown-inner").removeClass("menu__dropdown-inner--active menu__dropdown-inner--off-left menu__dropdown-inner--off-right");
            this.$nav.find(".menu__item--dropdown-active").removeClass("menu__item--dropdown-active");
        }, 20);
    }

}

export default NavigationHover;
